import React, { useState } from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Modal from "./Modal";

const ConfirmDialog = (props) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const confirm = () => {
    props.handleConfirm(props.data);
    setOpen(false);
  };

  return (
    <>
      <IconButton
       title={props.iconTitle} 
       size="small" 
       onClick={handleOpen}
       disabled={props.mostrar === 'N'}>
        {props.icon}
      </IconButton>

      <Modal open={open} handleClose={handleClose} size="sm">
        <Typography variant="titulo" paragraph>
          {props.text}
        </Typography>
        {props.subText ? (
          <Typography variant="cuerpo" paragraph>
            {props.subText}
          </Typography>
        ) : (
          ""
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <Button sx={{ m: 1 }} variant="verde" onClick={confirm}>
            {"Confirmar"}
          </Button>
          <Button sx={{ m: 1 }} variant="plata" onClick={handleClose}>
            {"Cancelar"}
          </Button>
        </Box>
      </Modal>
    </>
  );
};

ConfirmDialog.propTypes = {
  handleConfirm: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  subText: PropTypes.string,
  icon: PropTypes.element.isRequired,
  iconTitle: PropTypes.string.isRequired,
};

ConfirmDialog.defaultProps = {
  text: "¿Seguro/a que desea realizar esta acción?",
  subText: null,
};

export default ConfirmDialog;